import Modal from "./Modal";

class WidgetExtraCheckout {
  constructor(){
    this.wrapper = document.querySelector('.wrapper-booking');
    if(this.wrapper){
      this.extrasHiddenInput = this.wrapper.querySelector('input[name="extras"]');
      if(!this.extrasHiddenInput){
        return;
      }

      this.initShowExtrasModal();

      this.initInitialAddButtons();

      this.extrasInputs = [];
      this.initChooseQuantityGroups();

      this.continueToPaymentButton = this.wrapper.querySelector('.continue-to-payment');
      this.confirmExtrasButton = this.wrapper.querySelector('.confirm-extras');
      this.extras = {};

      //include the departure point choosing if the experience is a guided tour
      // this.initChooseDeparturePoint();
    }
  }

  initInitialAddButtons(){
    // Store mapping between groups and their initial buttons
    this.initialButtonsMap = new Map();

    const initialButtons = this.wrapper.querySelectorAll('.initial-add');
    initialButtons.forEach(button => {
      const plusInput = this.wrapper.querySelector(button.dataset.forPlus);
      const plusInputWrapper = plusInput.closest('.choose-qty-group');
      if(plusInput && plusInputWrapper){
        // Store the reference between group and button
        this.initialButtonsMap.set(plusInputWrapper, button);

        button.addEventListener('click', () => {
          button.classList.add('hidden');

          plusInput.dispatchEvent(new Event('click'));
          plusInputWrapper.classList.remove('hidden');
        });
      }
    });
  }

  /**
   * Initializes the choose quantity groups.
   *
   * @return {void}
   */
  initChooseQuantityGroups(){
    this.chooseQtyGroups = this.wrapper.querySelectorAll('.choose-qty-group');
    if(this.chooseQtyGroups){
      this.chooseQtyGroups.forEach(group => {
        const minus = group.querySelector('.minus');
        const plus = group.querySelector('.plus');
        const qty = group.querySelector('.qty');

        if(minus && plus && qty){
          //push the qty input into the extrasInputs array so we can check if there are extras selected in updateConfirmExtrasButtonText()
          this.extrasInputs.push(qty);

          minus.addEventListener('click', () => {
            if(Number(qty.value) > Number(qty.min)){
              if(Number(qty.value) > Number(qty.dataset.min)){
                qty.step = 1;
              }

              qty.stepDown();

              if(qty.value == 0){
                qty.step = qty.dataset.min;
              }

              if(qty.value == Number(qty.dataset.min) - 1){
                qty.value = 0;
                qty.step = qty.dataset.min;
              }

              //manually trigger the change event to update the displayed value since stepDown && stepUp don't do it
              qty.dispatchEvent(new Event('change'));

              this.extras[group.dataset.extraId] = qty.value;

              // If quantity is back to 0, show initial button and hide quantity group
              if(Number(qty.value) === 0){
                const initialButton = this.initialButtonsMap.get(group);
                if(initialButton){
                  initialButton.classList.remove('hidden');
                  group.classList.add('hidden');
                }
              }

              this.toggleDisableContinueToPaymentButtons(true);
              this.addExtras();
              this.updateConfirmExtrasButtonText();
            }
          });

          plus.addEventListener('click', () => {
            if(Number(qty.value) < Number(qty.max)){
              if(Number(qty.value) === Number(qty.dataset.min)){
                qty.step = 1;
              }

              qty.stepUp();

              if(Number(qty.value) !== Number(qty.dataset.min)){
                qty.step = 1;
              }

              //manually trigger the change event to update the displayed value since stepDown && stepUp don't do it
              qty.dispatchEvent(new Event('change'));

              this.extras[group.dataset.extraId] = qty.value;

              this.toggleDisableContinueToPaymentButtons(true);
              this.addExtras();
              this.updateConfirmExtrasButtonText();
            }
          });
        }
      });
    }
  }

  /**
   * Adds extras to the hidden input and toggles the disabled state of the continue to payment buttons.
   */
  addExtras(){
    this.extrasHiddenInput.value = JSON.stringify(this.extras);
    this.toggleDisableContinueToPaymentButtons(false);
  }

  /**
   * Toggles the disabled state of the continue to payment buttons.
   *
   * No parameters.
   *
   * No return value.
   */
  toggleDisableContinueToPaymentButtons(disabled){
    this.continueToPaymentButton.disabled = disabled;
  }

/**
 * Update the text of the confirm extras button depending whether or not there are extras in the cart.
 */
  updateConfirmExtrasButtonText(){
    if(this.confirmExtrasButton){
      let extrasAdded = false;

      //check in this.extrasInputs if there are extras in the cart
      this.extrasInputs.forEach(input => {
          if(input.value > 0){
            extrasAdded = true;
            return;
          }
      });

      this.confirmExtrasButton.textContent = extrasAdded ? this.confirmExtrasButton.dataset.extrasAddedText
                                                         : this.confirmExtrasButton.dataset.noExtrasText;
    }
  }

  // initChooseDeparturePoint(){
  //   this.addDeparturePointMobileNotice = this.wrapper.querySelector('#add-departure-point-mobile-notice');
  //   this.departurePointChoices = this.wrapper.querySelectorAll("input[name='departure_point']");
  //   if(this.departurePointChoices){
  //     this.departurePointChoices.forEach(choice => {
  //       choice.addEventListener('change', () => {
  //         if(choice.checked){
  //           //x = decided on the backend for safety
  //           this.extras[choice.dataset.extraId] = 'x';

  //           //remove any other departure points
  //           const uncheckedDeparturePoints = this.wrapper.querySelectorAll("input[name='departure_point']:not(:checked)");
  //           uncheckedDeparturePoints.forEach(uncheckedDP => {
  //             this.extras[uncheckedDP.dataset.extraId] = 0;
  //           });
  //         }

  //         this.toggleDisableContinueToPaymentButtons(true);
  //         this.addExtras();
  //       });
  //     });
  //   }
  // }

  initShowExtrasModal(){
    this.wrapper.addEventListener('click', (e) => {
      if(e.target.classList.contains('load-extras') || e.target.closest('.load-extras')){
        Modal.toggleModal('#pickExtras', false);

        // Dispatch modal-opened event for IframeHeightResizer to recalculate height
        document.dispatchEvent(new Event('modal-opened'));
      }
    });

    // Also observe the extras modal for close and dispatch modal-closed event
    const pickExtrasModal = document.getElementById('pickExtras');
    if (pickExtrasModal) {
      const modalCloseElements = pickExtrasModal.querySelectorAll('.modal-close, .modal-overlay');
      modalCloseElements.forEach(el => {
        el.addEventListener('click', () => {
          // Small delay to let the modal animation complete
          setTimeout(() => {
            document.dispatchEvent(new Event('modal-closed'));
          }, 100);
        });
      });

      // Also handle the confirm extras button that closes the modal
      const confirmExtrasBtn = pickExtrasModal.querySelector('.confirm-extras');
      if (confirmExtrasBtn) {
        confirmExtrasBtn.addEventListener('click', () => {
          setTimeout(() => {
            document.dispatchEvent(new Event('modal-closed'));
          }, 100);
        });
      }
    }
  }
}

export { WidgetExtraCheckout }
